module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-idaho-bccb064704aff0f48f2b63348cdff3f5.svg";